import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { RoundedIcon } from "../../rounded-icon/rounded-icon";

const LegendStyle = styled.div`
  margin: 6px 0 12px;
  font-size: 10px;
  width: 300px;
`;

const LegendItemsStyle = styled.div`
  display: flex;
  width: 300px;
  justify-content: center;
  background-color: ${(props) => props.theme.backgroundColor};
  border: 1px solid ${(props) => props.theme.informationTextBackgroundColor};
  border-radius: 4px;
  padding: 4px 0;
  margin: 6px auto;
`;

const LegendItem = styled.div`
  position: relative;
  display: flex;
  margin: 8px;
  justify-content: center;
  align-items: center;
`;

const LegendText = styled.div`
  margin-left: 8px;
`;

const Legend = () => {
  const { t } = useTranslation();
  return (
    <LegendStyle>
      <LegendItemsStyle className={"legend-items"}>
        <LegendItem data-test="waiting-icon">
          <RoundedIcon icon="waiting" size="legend" position="legend" />
          <LegendText>{t("instabook.legend.legend_waiting")}</LegendText>
        </LegendItem>
        <LegendItem data-test="flash-on-icon">
          <RoundedIcon icon="flash-on-icon" size="legend" position="legend" />
          <LegendText>{t("instabook.legend.legend_event")}</LegendText>
        </LegendItem>
        <LegendItem data-test="payment-icon">
          <RoundedIcon icon="payment-icon" size="legend" position="legend" />
          <LegendText>{t("instabook.legend.legend_prepay")}</LegendText>
        </LegendItem>
      </LegendItemsStyle>
    </LegendStyle>
  );
};
export const TimeSlotLegend = memo(Legend);
